import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    mensajitoEmpToken: "",
    mensajitoEmpUser: []
  },
  mutations: {
    login(state, data) {
      state.mensajitoEmpUser = data.user;
      state.mensajitoEmpToken = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.mensajitoEmpUser = [];
      state.mensajitoEmpToken = "";
    },
    usuario(state, data) {
      state.usuario = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("usuario", data);
    }
  }
});
